export const redirectTo = ({ redirectTo }) => {
  window.location = redirectTo;
  return null;
};
